import ReactLoading from "react-loading";

function Loading() {
  return (
    <div className="fixed w-[100%] z-40 left-0 h-[100%] bg-black opacity-40">
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <ReactLoading
          type={"spin"}
          color={"white"}
          height={"5vh"}
          width={"5vw"}
        />
      </div>
    </div>
  );
}

export { Loading };
